import { render, staticRenderFns } from "./CompanyHeader.vue?vue&type=template&id=479bcbe0"
import script from "./CompanyHeader.vue?vue&type=script&lang=js"
export * from "./CompanyHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports